import { blobticService } from '../../Commun/services/blobticService';
import { Template } from '../components/TemplateLibrary';
import { ShapeType } from '../services/windowsApi';

interface TemplateDto {
    TMP_IDF: number;
    TMP_UIDF?: string;
    TMP_CODE?: string;
    TMP_LIB: string;
    TMP_DESCRIPTION?: string;
    TMP_TYPE: string; // 'window' | 'door'
    TMP_JSON: string;
    TMP_ICON: string;
}

const mapDtoToModel = (dto: TemplateDto): Template => {
    let details = {};
    try {
        if (dto.TMP_JSON && dto.TMP_JSON.trim()) {
            details = JSON.parse(dto.TMP_JSON);
        }
    } catch (e) {
        console.error("Error parsing template JSON", e);
    }

    // Default values if JSON fails or is empty
    return {
        id: dto.TMP_IDF.toString(),
        name: dto.TMP_LIB,
        type: dto.TMP_TYPE as 'window' | 'door',
        icon: dto.TMP_ICON || '📦',
        description: dto.TMP_DESCRIPTION || '',
        defaultWidth: 1000,
        defaultHeight: 1000,
        shapeType: ShapeType.Rectangular,
        ...details
    } as Template;
};

const mapModelToDto = (model: Partial<Template>): any => {
    const { id, name, type, icon, ...details } = model;

    return {
        TMP_IDF: id && !isNaN(parseInt(id)) ? parseInt(id) : 0,
        TMP_LIB: name,
        TMP_DESCRIPTION: model.description,
        TMP_CODE: name?.toUpperCase().replace(/\s+/g, '_'),
        TMP_TYPE: type,
        TMP_ICON: icon,
        TMP_JSON: JSON.stringify(details)
    };
};

export const templatesApi = {
    getAll: async (type?: 'window' | 'door') => {
        const payload: any = {
            OKey: 'Blobtic_Maker,maker_template,Select'
        };
        if (type) payload.TMP_TYPE = type;

        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: payload
        });

        if (response.success && Array.isArray(response.data)) {
            return {
                data: response.data.map((item: any) => mapDtoToModel(item)),
                success: true
            };
        }
        return { data: [], success: false, message: response.message };
    },

    create: async (item: Partial<Template>) => {
        const dto = mapModelToDto(item);
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_template,Insert',
                ...dto
            }
        });
        return { success: response.success, message: response.message };
    },

    update: async (item: Partial<Template>) => {
        const dto = mapModelToDto(item);
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_template,Update',
                ...dto
            }
        });
        return { success: response.success, message: response.message };
    },

    delete: async (id: string) => {
        const response = await blobticService.executeZoomRequest({
            ZoomKey: 'Blobtic_Maker',
            Action: {
                OKey: 'Blobtic_Maker,maker_template,Delete',
                TMP_IDF: parseInt(id)
            }
        });
        return { success: response.success, message: response.message };
    }
};
